import { FC } from 'react'
import { Row, Col, Divider, Button } from '@mch-group/uikit-components'
import Text from '@components/Text'
import { findListItemByKeyValue } from './utils'

interface IPressAccProfileView {
  mID: string
  validProfile: boolean
  setProfileOpen: (value: boolean) => void
  mpapd_personal_lbl: string
  mpapd_edit_profile: string
  mpapd_name_and_surname_lbl: string
  mpapd_organization: string
  mpapd_function: string
  mpapd_media_type: string
  mpapd_contact_information: string
  mpapd_email: string
  mpapd_telephone: string
  mpapd_address: string
  mpapd_subscription_lbl: string
  mpapd_receiving_pp_by: string
  mpapd_no_information: string
  profile: any
  mediaFunctions: any
  mediaTypes: any
  countries: any
  salutations: any
  isProfileOpen: boolean
}

const ProfileView: FC<IPressAccProfileView> = ({
  mID,
  validProfile,
  setProfileOpen,
  mpapd_personal_lbl,
  mpapd_edit_profile,
  mpapd_name_and_surname_lbl,
  mpapd_organization,
  mpapd_function,
  mpapd_media_type,
  mpapd_contact_information,
  mpapd_email,
  mpapd_telephone,
  mpapd_address,
  mpapd_subscription_lbl,
  mpapd_receiving_pp_by,
  mpapd_no_information,
  profile,
  mediaFunctions,
  mediaTypes,
  countries,
  salutations
}) => (
  <Row className={`${mID}__view`} gutter='g-5 g-md-6 g-xl-7'>
    <Col xs={12} sm={12} md={3} lg={4} xl={3}>
      <Row>
        <Col
          xs={{ span: 6, offset: 3 }}
          sm={{ span: 6, offset: 3 }}
          md={{ span: 12, offset: 0 }}
          lg={{ span: 9, offset: 3 }}
          xl={{ span: 8, offset: 4 }}
          ></Col>
      </Row>
    </Col>
    <Col xs={12} sm={12} md={9} lg={8} xl={6}>
      <Row gutter='g-1 g-md-6 g-xl-7'>
        <Col md={12}>
          {/* Personal / Edit Profile button */}
          <Row gutter='g-5 g-md-6 g-xl-7' className='position-relative'>
            <Col md={12} className='mb-5 mb-md-5 mb-lg-5 mb-xl-5 edit-profile'>
              <h3 className='h5'>{mpapd_personal_lbl || 'Personal'}</h3>
              <Button
                icon='edit'
                iconAlign='left'
                onClick={() => setProfileOpen(true)}
                variant='secondary'
                size='compact'
                >
                {mpapd_edit_profile || 'Edit Profile'}
              </Button>
            </Col>
          </Row>

          {/* Name and Surname */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_name_and_surname_lbl || 'Name and surname'}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall>
                {`${findListItemByKeyValue(profile?.mailingSalutationId, salutations, 'code', 'value') || ''}
                      ${profile.firstName} ${profile.lastName}`}
              </Text>
            </Col>
          </Row>

          {/* Organization / Company */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_organization}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall isPlaceHolder={!profile.companyName}>
                {profile.companyName || mpapd_no_information}
              </Text>
            </Col>
          </Row>

          {/* Function */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_function}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall isPlaceHolder={!profile?.mediaFunction}>
                {findListItemByKeyValue(profile?.mediaFunction, mediaFunctions, 'code', 'value') ||
                    mpapd_no_information}
              </Text>
            </Col>
          </Row>

          {/* Media Type */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_media_type}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall isPlaceHolder={!profile?.mediaType}>
                {findListItemByKeyValue(profile?.mediaType, mediaTypes, 'code', 'value') ||
                    mpapd_no_information}
              </Text>
            </Col>
          </Row>

          {/* Divider */}
          <Row>
            <Col xs={9} lg={9} xl={10}>
              <Divider
                color='mch-gray-200'
                size='m'
                className='mt-3 mt-md-3 mt-lg-3 mt-xl-3 mb-8 mb-md-8 mb-lg-8 mb-xl-9'
                />
            </Col>
          </Row>

          {/* Contact information */}
          <Row>
            <Col md={9} className='mb-5 mb-md-5 mb-lg-5 mb-xl-7'>
              <h3 className='h5'>{mpapd_contact_information || 'Contact Information'}</h3>
            </Col>
          </Row>

          {/* email */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_email}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall>
                {profile?.email || mpapd_no_information}
              </Text>
            </Col>
          </Row>

          {/* phone */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_telephone}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall isPlaceHolder={!profile?.telephone}>
                {profile?.telephone || mpapd_no_information}
              </Text>
            </Col>
          </Row>

          {/* address */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_address}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              <Text forwardedAs='p' isSmall>
                {validProfile ? (
                  <Text forwardedAs='div' isSmall>
                    {profile?.street1 || ''}
                    {profile?.street1 ? <br /> : ''}
                    {profile?.street2 || ''}
                    {profile?.street2 ? <br /> : ''}
                    {profile?.street3 || ''}
                    {profile?.street3 ? <br /> : ''}
                    {profile?.postOfficeBox || ''}
                    {profile?.postOfficeBox ? <br /> : ''}
                    {profile?.zipCode ? `${profile?.zipCode} ` : ''}
                    {profile?.city ? `${profile?.city} ` : ''}
                    {profile?.state ? `${profile?.state} ` : ''}
                    {profile?.state ? <br /> : ''}
                    {profile?.countryCode
                        ? findListItemByKeyValue(profile?.countryCode, countries, 'crmGuid', 'name')
                        : ''}
                  </Text>
                  ) : (
                    <Text forwardedAs='p' isSmall isPlaceHolder>
                      {mpapd_no_information}
                    </Text>
                  )}
              </Text>
            </Col>
          </Row>

          {/* Press Releases via Email */}
          <Row>
            <Col md={4} className='mt-5 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-label'>
              <Text isSmall isStrong>
                {mpapd_subscription_lbl || 'Subscription'}
              </Text>
            </Col>
            <Col md={8} className='mt-0 mt-md-7 mt-xl-8 mb-3 mb-md-3 mb-lg-3 mb-xl-4 field-value'>
              {profile?.pressReleaseSubscribed ? (
                <Text forwardedAs='p' isSmall>
                  {mpapd_receiving_pp_by}
                </Text>
                ) : (
                  mpapd_no_information
                )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  </Row>
  )

export default ProfileView
